import type {
  ResponsiveValue,
  ShadowProps,
  TypographyProps,
} from 'styled-system';
import { shadow, typography } from 'styled-system';

import type {
  CursorProps,
  GridItemProps,
  TextDecorationProps,
  TextRenderingProps,
  TextTransformProps,
  TextWrapProps,
  UserSelectProps,
  WhiteSpaceProps,
} from '../extensions';
import {
  cursor,
  gridItem,
  textDecoration,
  textRendering,
  textTransform,
  textWrap,
  userSelect,
  whiteSpace,
} from '../extensions';
import styledFactory from '../styledFactory';
import variantFactory from '../variantFactory';

export interface Props
  extends CursorProps,
    GridItemProps,
    ShadowProps,
    TextDecorationProps,
    TextRenderingProps,
    TextTransformProps,
    TextWrapProps,
    TypographyProps,
    UserSelectProps,
    WhiteSpaceProps {
  variant?: ResponsiveValue<string>;
  __anchorCommon__?: 'common';
}

/**
 * Anchor is a component that renders a styled anchor (a) element.
 */
const Anchor = styledFactory<Props, 'a'>(
  'a',
  'Anchor',
  [
    variantFactory('components.anchor', { prop: '__anchorCommon__' }),
    variantFactory('components.anchor.variants'),
  ],
  [
    cursor,
    gridItem,
    shadow,
    textDecoration,
    textRendering,
    textTransform,
    textWrap,
    typography,
    userSelect,
    whiteSpace,
  ],
  undefined,
  {
    variant: 'default',
    __anchorCommon__: 'common',
  },
);

export default Anchor;
